import React from 'react';
import { ErrorMessage } from '@hookform/error-message';
import { useFormContext } from 'react-hook-form';

type Props = {
  name: string;
  label: string;
  noteMessage?: string;
};

export const InputField: React.FC<Props> = ({
  name,
  label,
  noteMessage,
  children,
}) => {
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <div className="form-input__wrap">
      {children}
      <ErrorMessage
        errors={errors}
        name={name}
        render={({ message }) => {

          return(
            <span className="form-input__error">
              {label}は{message}
            </span>
          );}}
      />
      {!!noteMessage && <span className="form-input__note">{noteMessage}</span>}
    </div>
  );
};
